import {Route} from 'react-router-dom';
import Error from './Error';

const ErrorRoute = () => {
  return <Route key="error" path="/error" render={() => <Error />} />;
};

export default ErrorRoute;
